import * as pdfjs from 'pdfjs-dist/legacy/build/pdf.mjs';
// Served from our own build. From unpkg, Safari refused the cross-origin
// module worker ("Setting up fake worker failed") and the Android app could
// not open a drawing without internet.
import pdfjsWorkerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url';
// import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker?worker';
import * as Sentry from '@sentry/vue';


const init = () => {
  try {
    if (typeof window === 'undefined' || !('Worker' in window)) {
      throw new Error('Web Workers not supported in this environment.');
    }

    // window.pdfjsWorker = pdfjsWorker;
    pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorkerUrl
    // pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/legacy/build/pdf.worker.mjs`;
  } catch (error) {
    Sentry.captureException(`Unable to load pdfjs: ${error}`);
  }
};

export default {
  install: (app) => {
    init();
    app.config.globalProperties.$pdf = pdfjs;
  }
};
